import { useTranslation } from "react-i18next";
import { Form } from "semantic-ui-react";

import { Can, TableView } from "components";
import { createFormHelper } from "lib/Form";
import { BrandLogoUpload } from "modules/BrandsDashboard/components/BrandSettingsFields/components";
import { isValidUrl } from "modules/BrandsDashboard/utils";

import type { Brand } from "models";

export type BrandSettingsFormValues = Pick<
  Brand,
  | "country"
  | "color"
  | "is_active"
  | "button_label"
  | "tablet_service_button_url"
  | "servicebox_wo"
  | "servicebox_vin"
  | "servicebox_wo_2_name"
  | "servicebox_wo_2"
  | "logo"
> & { logoFile: File | null };

const FormHelper = createFormHelper<BrandSettingsFormValues>();

export const BrandSettingsFields = () => {
  const { t } = useTranslation();
  const { watch, formState } = FormHelper.useFormContext();

  const [serviceboxWo, serviceboxVin, tabletServiceButtonUrl, serviceboxWo2] = watch(["servicebox_wo", "servicebox_vin", "tablet_service_button_url", "servicebox_wo_2"]);

  return (
    <>
      <Form.Group widths="equal">
        <Form.Field>
          <label>{t("v8_country", "Country")}</label>
          <FormHelper.Field.Input name="country" inputProps={{ placeholder: t("v8_country", "Country") }} />
        </Form.Field>
        <Form.Field>
          <label>{t("v8_color", "Color")}</label>
          <FormHelper.Field.ColorPicker name="color" />
        </Form.Field>
      </Form.Group>

      <div className="table-cells-padding">
        <TableView
          cells={["{{.Appointment.VIN}}", "{{.Appointment.WONr}}", "{{.Appointment.CurrentKM}}", "{{.Appointment.NextKM}}", "{{.JobDate}}", "{{.XentryJobID}}"]}
          nrOfCells={2}
        />
      </div>

      <Form.Field>
        <label>{t("v8_button_label", "Button label")}</label>
        <FormHelper.Field.Input name="button_label" inputProps={{ placeholder: t("v8_button_label", "Button label") }} />
      </Form.Field>
      <Form.Field error={formState.isSubmitted && !isValidUrl(tabletServiceButtonUrl)}>
        <label>{t("v8_tablet_service_button_url", "Tablet Service button URL")}</label>
        <FormHelper.Field.Input name="tablet_service_button_url" inputProps={{ placeholder: t("v8_tablet_service_button_url", "Tablet Service button URL") }} />
      </Form.Field>
      <Form.Field error={formState.isSubmitted && !isValidUrl(serviceboxWo)}>
        <label>{t("v8_appointment_service_button_url", "Appointment service button URL")}</label>
        <FormHelper.Field.Input name="servicebox_wo" inputProps={{ placeholder: t("v8_appointment_service_button_url", "Appointment service button URL") }} />
      </Form.Field>
      <Form.Field error={formState.isSubmitted && !isValidUrl(serviceboxVin)}>
        <label>{t("v8_car_detail_service_button_url", "Car detail service button URL")}</label>
        <FormHelper.Field.Input name="servicebox_vin" inputProps={{ placeholder: t("v8_car_detail_service_button_url", "Car detail service button URL") }} />
      </Form.Field>

      <Form.Field>
        <label>{t("v8_button_label_2", "Button label 2")}</label>
        <FormHelper.Field.Input name="servicebox_wo_2_name" inputProps={{ placeholder: t("v8_button_label_2", "Button label 2") }} />
      </Form.Field>
      <Form.Field error={formState.isSubmitted && !isValidUrl(serviceboxWo2)}>
        <label>{t("v8_wo_detail_button_2_url", "WO Detail button 2 URL")}</label>
        <FormHelper.Field.Input name="servicebox_wo_2" inputProps={{ placeholder: t("v8_wo_detail_button_2_url", "WO Detail button 2 URL") }} />
      </Form.Field>

      <Can I="create" the="files">
        <Form.Field>
          <label>{t("v8_logo", "Logo")}</label>
          <BrandLogoUpload />
        </Form.Field>
      </Can>
    </>
  );
};
